import { z } from "zod";

/**
 * Search parameters of the `/channels` route.
 *
 * `?create=line` opens the add-channel modal with LINE selected; CAAC links
 * here to connect a LINE OA. Unknown values are dropped rather than failing
 * the route. Other parameters pass through, so clearing `create` keeps them.
 */
export const channelsSearchSchema = z
  .object({
    create: z.literal("line").optional().catch(undefined),
  })
  .passthrough();
